import React  from 'react';
import CardboardChain from '../CardboardChain';
import * as ActionModifiers from '../ActionModifiers';
import NormalBtn from '../StockItems/NormalBtn';

function App(props) {

  var setSelectedStep = props.setSelectedStep;
  var currentList = props.currentList;
  var accessLevel = props.accessLevel;
  var simplDuplicate = props.simplDuplicate;
  var changeShowWhat = props.changeShowWhat;
  var addToExtraScreen = props.addToExtraScreen;
  var chains = props.chains;
  var clickBack = props.clickBack;
  var changeTab = props.changeTab;

  var canCode = true;
   var p = ActionModifiers.actionMods(currentList, [], 'databaseWrite', chains, changeTab);
   if (p.length > 0){
    canCode = false;
   }

  function clickCredits(e){
    addToExtraScreen({t:'credits', v:0})
  }

  if (accessLevel < 5){
    return <div className='container'>
      <div className='row mb-4'>
      <div className='col-lg-10 mx-auto text-center'>
        <br/>
        <br/>
        <p className='lead mb-0'>Sorry you do not have the access rights to launch this dAPp. Click the button below to duplicate the dApp so that you can launch it.</p><br/>
        <NormalBtn onClick={simplDuplicate} title='Duplicate ' />
      </div></div></div>
//    
       // 
  }

    function selectX(x){
      return function(e){
        setSelectedStep(['de', x])
      }
    }

    var warning;
    var tabitems = [];

    var p1 = ActionModifiers.actionMods(currentList, [], 'placeholder', chains, changeTab);
    if (p1.length > 0){
      warning = <div className='lead mb-0'>Please fill up your placeholders first before previewing or launching dApp.</div>
//
    }else{

      function noCode(){
        window.alert('Code is not currently available for your dapp because of the database write call. If you are interested in generating code for such a dapp, please let us know via the feedback function and we will prioritise this development. Thank you.');
      }
      tabitems = [
        {t:'Preview dApp', a:'icon-park-outline:preview-open', f:changeShowWhat('pr')},
        {t:'Launch dApp on Cues.sg', a:'bx:rocket', f:selectX('launch')}];

     if (canCode){
      // tabitems.push({t:'Get Code to deploy dApp on your own server', a:'entypo:code', f:selectX('code')});
     }else{
      tabitems.push({t:'Code not available', a:'entypo:code', f:noCode})
     }

    }

   tabitems.push({t:'Top up credits to launch dApp. Trying is free.', a:'ph:coin', f:clickCredits});

  function clickSharingStatus(e){
    addToExtraScreen({t:'sharingStatus'})
  }

   tabitems.push({t:'Share project with other collaborators. They will be able to edit the project with you.', a:'bi:share', f:clickSharingStatus});

  function clickFeedback(e){
    addToExtraScreen({t:'feedback'})
  }


  tabitems.push({t:'Feedback', a:'codicon:feedback', f:clickFeedback});

// changeShowWhat('edit' )
    var items = <CardboardChain tabitems={tabitems}/>

    return <div className='container py-5'>
        <div className='row'>
          <NormalBtn onClick={clickBack} title='Back' />
        </div>
        {warning}
      <div className='row'>
        {items}
        </div>
        </div>
}

export default App;
